<template lang="html">
  <UInput
    v-maska="'+7 ### ###-##-##'"
    placeholder="Введите номер телефона"
    icon="i-lucide-phone"
  />
</template>

<script setup lang="ts">
import { vMaska } from 'maska/vue'
</script>
